/*! loadJS: load a JS file asynchronously. [c]2014 @scottjehl, Filament Group, Inc. (Based on http://goo.gl/REQGQ by Paul Irish). Licensed MIT */
(function( w ){
    var loadJS = function( src, cb ){
      "use strict";
      var ref = w.document.getElementsByTagName( "script" )[ 0 ];
      var script = w.document.createElement( "script" );
      script.src = src;
      script.async = true;
      ref.parentNode.insertBefore( script, ref );
      if (cb && typeof(cb) === "function") {
        script.onload = cb;
      }
      return script;
    };
    w.loadJS = loadJS;
  }( typeof global !== "undefined" ? global : this ));
  
  window.theme = window.theme || {};
  
  theme.utils = {
  
    /**
     * Locks the page scroll.
     *
     * @param      {element}  scrollEl  optional
     */
    lockPageScroll: function(scrollEl) {
  
      document.documentElement.classList.add('scroll-locked');
  
  
      if ('bodyScrollLock' in window) {
        bodyScrollLock.lock(scrollEl);
      }
  
    },
  
      /**
     * Unlocks the page scroll.
     */
    unlockPageScroll: function() {
  
      document.documentElement.classList.remove('scroll-locked');
  
  
      if ('bodyScrollLock' in window) {
        bodyScrollLock.unlock();
      }
    },
  
    /**
     * Turns a string into a handle. Mimics Shopify's format.
     */
    handleize: function(str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },
  
    /**
     * Cross-browser URL query param getter
     */
    getQueryParams: function(qs) {
      qs = qs || document.location.search;
  
      if (!qs) {
        return;
      }
  
      qs = qs.split('+').join(' ');
  
      var params = {},
          tokens,
          re = /[?&]?([^=]+)=([^&]*)/g;
  
      while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
      }
  
      return params;
    },
  
    updateQueryStringParameter: function(key, value, url) {
      if (!url) url = window.location.href;
  
      var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;
  
      if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null)
          return url.replace(re, '$1' + key + "=" + value + '$2$3');
        else {
          hash = url.split('#');
          url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
          if (typeof hash[1] !== 'undefined' && hash[1] !== null)
            url += '#' + hash[1];
          return url;
        }
      } else {
        if (typeof value !== 'undefined' && value !== null) {
          var separator = url.indexOf('?') !== -1 ? '&' : '?';
          hash = url.split('#');
          url = hash[0] + separator + key + '=' + value;
          if (typeof hash[1] !== 'undefined' && hash[1] !== null)
            url += '#' + hash[1];
          return url;
        }
        else
          return url;
      }
    },
  
    getYoutubeId: function(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    },
  
    getProductJSON: function(handle, callback) {
      return $.get('/products/' + handle + '?view=json', null, callback, 'text');
    },
  
    hexToRgb: function(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
  
    forceRedraw: function(elem) {
      if (!elem) {
        return;
      }
  
      var disp = elem.style.display;
      elem.style.display = 'none';
      var redrawElem = elem.offsetHeight;
      elem.style.display = disp;
    },
  
    flash: function(elements, color, duration) {
      var opacity = 100;
      color = color || '255, 255, 136';
      duration = duration || 1500;
  
      if (color.indexOf('#') > -1) {
        var rgbColor = theme.utils.hexToRgb(color);
        color = [rgbColor.r,rgbColor.g,rgbColor.b].join(',');
      }
  
      var interval = setInterval(function() {
        opacity -= 2.5;
  
        $(elements).css({ background: 'rgba(' + color + ', ' + opacity / 100 + ')' });
  
        if (opacity <= 0) {
          clearInterval(interval);
          return;
        }
      }, duration / 40);
    },
  
    // returns cross-browser CSS property name
    getCSSProperty: function(propertyName) {
      var properties;
  
      switch(propertyName) {
  
        case 'transform':
          properties = ['transform', 'msTransform', 'webkitTransform', 'mozTransform', 'oTransform'];
          break;
  
        case 'background-color':
          properties = ['background-color'];
          break;
  
        case 'color':
          properties = ['color'];
          break;
  
        case 'left':
          properties = ['left'];
          break;
      }
  
      function getSupportedPropertyName(properties) {
        for (var i = 0; i < properties.length; i++) {
          if (typeof document.body.style[properties[i]] != 'undefined') {
            return properties[i];
          }
        }
        return null;
      }
  
      return getSupportedPropertyName(properties);
    },
  
    getOffset: function(el) {
      var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    },
  
    // Gets the rendered size of an image using object-fit
    getRenderedImgSize: function(contains, cWidth, cHeight, width, height, pos){
      var oRatio = width / height,
      cRatio = cWidth / cHeight;
      return function() {
        if (contains ? (oRatio > cRatio) : (oRatio < cRatio)) {
          this.width = cWidth;
          this.height = cWidth / oRatio;
        } else {
          this.width = cHeight * oRatio;
          this.height = cHeight;
        }
        this.left = (cWidth - this.width)*(pos/100);
        this.right = this.width + this.left;
        return this;
      }.call({});
    },
  
    // Returns size info for an image rendered with object-fit
    getImgSizeInfo: function(img) {
      var pos = window.getComputedStyle(img).getPropertyValue('object-position').split(' ');
      return theme.utils.getRenderedImgSize(true,
        img.width,
        img.height,
        img.naturalWidth,
        img.naturalHeight,
        parseInt(pos[0]));
    },
  
    // Returns content of template placed into snippets/js-tempales.liquid
    getTemplate: function(template) {
      return document.querySelector('[data-template-for="' + template + '"]').innerHTML;
    },
  
    // Create an element from a HTML string
    createElementFromHTML: function(htmlString) {
      var div = document.createElement('div');
      div.innerHTML = htmlString ? htmlString.trim() : '<div></div>';
      return div.firstChild;
    },
  
    // Returns deep differences between objects, ignoring functions
    difference: function(object, base) {
      function changes(object, base) {
        return _.transform(object, function(result, value, key) {
          if (typeof value !== 'function' && !_.isEqual(value, base[key])) {
            var comparison = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
  
            if (!_.isNil(comparison)) {
              result[key] = comparison;
            }
          }
        });
      }
      return changes(object, base);
    },
  
    // Adds syntax highlighting to JSON output
    syntaxHighlight: function(json) {
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      json = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      });
      json = json.replace(/([\n\r]|^)(\s*){/g, '<span class="group">$2<span class="group-handle">{</span>').replace(/([\n\r]|^)(\s*)}(,|)/g, '$1$2}$3</span>');
      json = json.replace(/(<\/span>|^)(\s*)\[/g, '$1<span class="group group--inline">$2<span class="group-handle">[</span>').replace(/([\n\r]|^)(\s*)](,|)/g, '$2]$3</span>');
      return json;
    },
  
    getStyleValue: function(variable) {
      var value = window.getComputedStyle(document.documentElement).getPropertyValue(variable);
      if (value) {
        return value.trim();
      }
      return '';
    },
  
  
    getBottomOffsetFromViewportTop: function(el) {
      var rect = el.getBoundingClientRect();
      return rect.top + rect.height;
    },
  
    errorTippy: function(target, message) {
      var $el = $(target);
      var tip = tippy($el[0], {
        showOnInit: true,
        content: message,
        theme: 'light',
        animation: 'shift-away',
        arrow: true,
        delay: [0, 1000],
        onHidden: function(e) {
          e.destroy();
        }
      });
    },
  
    showError: function(message) {
      iziToast.show({
        message: message,
        color: 'red',
        position: 'bottomCenter'
      });
    },
  
    highlightSubString: function(substring, string) {
      return substring ? string.replace(new RegExp(substring, 'gi'), function (str) {
        return '<strong>' + str + '</strong>';
      }) : '';
    }
  
  };
  
  if ('tinybind' in window) {
  
    tinybind.formatters.replace = function(value, search, replace) {
      return value.replace(search, replace);
    };
  
    tinybind.formatters.handle = function(string) {
      return theme.utils.handleize(string);
    };
  
    tinybind.formatters.includesValue = function(array, value) {
      // console.log(array.findIndex(value))
      return _.indexOf(array, value) > -1
    };
  
    tinybind.formatters.startsWith = function(value, prefix) {
      return value.indexOf(prefix) === 0;
    };
  
    tinybind.formatters.endsWith = function(value, suffix) {
      return value.indexOf(suffix, value.length - suffix.length) !== -1;
    };
  
    tinybind.formatters.gte = function(a, b) {
      return a >= b;
    };
  
    tinybind.formatters.or = function(a, b) {
      return a || b;
    };
  
    tinybind.formatters.and = function(a, b) {
      return a && b;
    };
  
    tinybind.formatters.eq = function(a, b) {
      return a == b;
    };
  
    tinybind.formatters.size = function(a) {
      return a ? _.size(a) : 0;
    };
  
    tinybind.formatters.style = function(a, b) {
      return b + ': ' + a + ';'
    };
  
    tinybind.formatters.array_element = function(a, b) {
      return a[b];
    };
  
    tinybind.formatters.prepend = function(a, b) {
      return b + a;
    };
  
    tinybind.formatters.append = function(a, b) {
      return a + b;
    };
  
    tinybind.binders.transformx = function(el, value) {
      el.style[theme.utils.getCSSProperty('transform')] = 'translateX(' + value + ')';
    };
  
    tinybind.binders['background-color'] = function(el, value) {
      el.style[theme.utils.getCSSProperty('background-color')] = value ;
    };
  
    tinybind.binders['color'] = function(el, value) {
      el.style[theme.utils.getCSSProperty('color')] = value ;
    };
  
    tinybind.formatters.length = tinybind.formatters.size;
  
    tinybind.formatters.stripHtml = function(html) {
      var parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      return parsedHtml.body.textContent || "";
    };
  
    tinybind.formatters.escape = function(string) {
      return JSON.stringify(string).replace(/(^"|"$)/g, '');
    };
  
    tinybind.formatters.json = function(a) {
      return JSON.stringify(a);
    };
  
    tinybind.formatters.json_parse = function(a) {
      console.log(a);
      return JSON.parse(a);
    };
  
    tinybind.formatters.log = function(value) {
      console.log(value);
      return value;
    };
  
    tinybind.formatters.debug = function(value) {
      debugger;
      return value;
    };
  
    tinybind.formatters.format_tel = function(value) {
      if (!value) {
        return '';
      }
      return value.replace(/\ /g, '');
    };
  
    tinybind.formatters.array_position = function(array, value) {
      return (value >= 0 ? array[value] : array[array.length + value]);
    };
  
    tinybind.formatters.percentage_of = function(a, b) {
      return b / a * 100;
    };
  
    tinybind.formatters.contains = function(a, b) {
      return (a.indexOf(b) > -1);
    };
  
    tinybind.formatters.imageExists = function(a) {
      return (a && a.indexOf('no-image') == -1);
    };
  
    tinybind.formatters.highlight = function(a, b) {
      if (b && a) {
        return theme.utils.highlightSubString(b, a);
      }
      return;
    };
  
    tinybind.formatters.disableQuickAdd = function(a) {
      var productType = a.product_type || a.type || null;
      return productType == 'Bundle' || a.tags.indexOf('in-store-only') > -1;
    };
  
  
  
    tinybind.formatters.has_flavor = function(a) {
      if (!a) {
        return
      }
  
      for (var i = 0; i < a.length; i++) {
        var option = a[i];
  
        if(option.name == 'flavor'){
          return true;
        }
      }
      return false;
    };
  
  
    tinybind.formatters.enableAddToCart = function(a) {
      if(a.variants.length > 1){
        return false;
      }
      if(a.type == 'Bundle'){
        return false;
      }
      return true;
  
    };
  
    tinybind.formatters.get_flavor_count = function(a) {
      for (var i = 0; i < a.length; i++) {
        var option = a[i];
        if(option.name == 'flavor'){
          return option.values.length;
        }
      }
      return false;
    };
  
    tinybind.formatters.img = function(image, alt, maxWidth, maxHeight) {
  
      if (!image) {
        return;
      }
  
      var imgTemplateURL,
          imgString,
          imgUrl,
          imgPlaceholderUrl;
  
      imgUrl = (typeof image == 'string' ? image : image.src) || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  
      if (imgUrl.indexOf('{width}x') == -1) {
        imgTemplateURL = slate.Image.getSizedImageUrl(imgUrl, '{width}x');
        imgPlaceholderUrl = slate.Image.getSizedImageUrl(imgUrl, '100x');
      } else {
        imgTemplateURL = imgUrl;
        imgPlaceholderUrl = imgTemplateURL.replace('{width}x', '100x')
      }
  
      maxWidth = maxWidth ? ((image.width ? image.width + 'px' : false) || (typeof maxWidth == 'string' ? maxWidth : maxWidth + 'px')) : 'none';
      maxHeight = maxHeight ? ((image.height ? image.height + 'px' : false) || (typeof maxHeight == 'string' ? maxHeight : maxHeight + 'px')) : 'none';
  
      alt = alt || null;
  
      // imgPlaceholderUrl = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  
      imgString = '<img src="' + imgPlaceholderUrl + '" class="lazyload" style="max-width: ' + maxWidth + '; max-height: ' + maxHeight + ';" data-sizes="auto" data-src="' + imgTemplateURL + '" alt="' + alt + ' "/>'
  
      return imgString;
    };
  
    tinybind.formatters.map = function(a, b) {
      return _.map(a, b);
    };
  
    tinybind.binders.selected = function(el, value) {
      if (value) {
        el.selected = 'selected';
      }
    };
  
    tinybind.binders['product-grid-item'] = function(el, product) {
      var gridIndex = el.dataset.index;
      var animateIn = typeof el.dataset.animateIn != 'undefined' ? el.dataset.animateIn : true;
      var options = {
        animateIn: animateIn == 'true' ? true : false
      };
  
      //initalising all js product grid items i.e collection pages
      new theme.ProductGridItem(el, product);
    };
  
    tinybind.binders['cart-add'] = {
      bind: function(el) {
  
        var self = this;
  
        this.callback = function(variantId) {
          var variantId = self.variantId || el.dataset.variantId;
          var quantity = el.dataset.quantity || 1;
          var propertyInputs = el.parentElement.getElementsByTagName('input');
          var properties = Array.prototype.map.call(propertyInputs, function(propertyInput) {
            if (propertyInput.name.indexOf('properties') == -1) {
              return false;
            }
            var properyName = propertyInput.name.replace('properties[', '').replace(']', '');
            var obj = {};
            obj[properyName] = propertyInput.value;
            return obj
          })
          properties = _.assign.apply(_, properties);
          el.classList.add('loading');
          CartJS.addItem(variantId, quantity, properties);
        }
  
        el.addEventListener('click', this.callback);
      },
  
      unbind: function(el) {
        el.removeEventListener('click', this.callback);
      },
  
      routine: function(el, value) {
        this.variantId = value;
      }
    };
  
    tinybind.binders['slideshow'] = {
  
      bind: function(el) {
        this.el;
        this.track;
        this.slides;
        this.buttons;
        this.isInit = false;
        this.currentSlideIndex = 0;
        this.slidesToShow = 1;
  
        var NAMESPACE = 'slideshow';
        var SLIDSHOW_ELEMENT_CLASS_NAME = 'slideshow-view';
        var SLIDSHOW_BUTTONS_CLASS_NAME = 'slideshow-button';
        var NEXT_DIRECTION_NAME = 'next';
        var PREV_DIRECTION_NAME = 'previous';
  
        var self = this;
  
        var enableOrDisableButton = function(button) {
          var direction = button.name;
          if (direction == NEXT_DIRECTION_NAME && self.currentSlideIndex == self.slides.length - 1) {
            button.disabled = true;
          } else if (direction == PREV_DIRECTION_NAME && self.currentSlideIndex == 0) {
            button.disabled = true;
          } else {
            button.disabled = false;
          }
        };
  
        var goToNextSlide = function() {
          if (self.currentSlideIndex < self.slides.length - 1) {
            goToSlide(self.currentSlideIndex + 1);
          }
        };
  
        var goToPrevSlide = function() {
          if (self.currentSlideIndex > 0) {
            goToSlide(self.currentSlideIndex - 1);
          }
        };
  
        var goToSlide = function(slideIndex) {
          var currentSlide = self.slides[self.currentSlideIndex];
          var targetSlide = self.slides[slideIndex];
  
          self.track.style.transform = 'translateX(' + slideIndex / self.slidesToShow * -100 + '%)';
  
          currentSlide.setAttribute('aria-hidden', true);
          targetSlide.setAttribute('aria-hidden', false);
  
          self.currentSlideIndex = slideIndex;
  
          Array.prototype.forEach.call(self.buttons, function(button) {
            enableOrDisableButton(button);
          });
        };
  
        var getButtonsTemplate = function(direction) {
          var templateNamePrefix = 'slider-button-';
          return theme.utils.getTemplate(templateNamePrefix + direction);
        };
  
        this._createSlideshow = function(el, options) {
          if (self.isInit) {
            this._destroySlideshow(el);
          }
          self.track = self.el.firstElementChild;
          self.slides = self.track.children;
  
          self.el.classList.add(SLIDSHOW_ELEMENT_CLASS_NAME);
  
          Array.prototype.forEach.call(self.slides, function(slide, index) {
            slide.setAttribute('aria-hidden', index != self.currentSlideIndex);
          });
  
          self.el.addEventListener(NEXT_DIRECTION_NAME + '.' + NAMESPACE, goToNextSlide);
          self.el.addEventListener(PREV_DIRECTION_NAME + '.' + NAMESPACE, goToPrevSlide);
  
          self.buttons = [NEXT_DIRECTION_NAME, PREV_DIRECTION_NAME].map(function(direction) {
            var button = document.createElement('button');
  
            button.setAttribute('name', direction);
  
            button.classList.add(SLIDSHOW_BUTTONS_CLASS_NAME);
            button.classList.add(SLIDSHOW_BUTTONS_CLASS_NAME + '--' + direction);
  
            button.innerHTML = getButtonsTemplate(direction);
  
            button.addEventListener('click', function() {
              self.el.dispatchEvent(new Event(direction + '.' + NAMESPACE));
            });
  
            self.el.appendChild(button);
  
            enableOrDisableButton(button);
  
            return button;
          });
  
          self.isInit = true;
  
        };
  
        this._destroySlideshow = function(el) {
  
          if (!self.isInit) {
            return;
          }
  
          self.el.classList.remove(SLIDSHOW_ELEMENT_CLASS_NAME);
  
          self.el.removeEventListener(NEXT_DIRECTION_NAME + '.' + NAMESPACE, self.nextSlide);
          self.el.removeEventListener(PREV_DIRECTION_NAME + '.' + NAMESPACE, self.prevSlide);
  
          Array.prototype.forEach.call(self.buttons, function(button) {
            button.remove();
          });
  
          self.isInit = false;
  
        };
  
      },
  
      unbind: function(el) {
        this._destroySlideshow(el);
      },
  
      routine: function(el, value) {
        value ? this._createSlideshow(el) : this._destroySlideshow(el);
      }
  
    };
  
    tinybind.binders.transformx = function(el, value) {
      el.style[theme.utils.getCSSProperty('transform')] = 'translateX(' + value + ')';
    };
  
    tinybind.binders.left = function(el, value) {
      el.style[theme.utils.getCSSProperty('left')] = value;
    };
  
    tinybind.binders['scroll-to'] = function(el, value) {
      var parent;
  
      if (value) {
        parent = el.parentElement;
        $(parent).scrollTo(el, {
            duration: 500,
            interrupt: !isMobile.apple.device,
            offset: -20
        });
      }
    };
  
    tinybind.formatters.highlight = function(a, b) {
      if (b && a) {
        return theme.utils.highlightSubString(b, a);
      }
      return;
    };
  
    tinybind.formatters.any = function(a) {
      var i, args = Array.prototype.slice.call(arguments, 1);
      i = args.length;
      while(i--) {
        if (args[i] && typeof args[i] != 'undefined' && !(Array.isArray(args[i]) && args[i].length == 0)) {
          return true;
        }
      }
      return false;
    };
  
    tinybind.binders['tooltip'] = function(el, value) {
      var defaultOptions = {
        theme: 'light'
      };
      var options = typeof value == 'string' ? { content: value } : value;
      'tippy' in window && options.content && tippy(el, _.defaults(options, defaultOptions))
    };
  
  }
  
  window.theme = window.theme || {};
  
  theme.StoreLocator = (function() {
  
    var selectors = {
      storesDataContainer: 'script#store-locations',
      filtersDataContainer: 'script#store-location-filters',
      mapContainer: '#Map-'
    };
  
    var saturation = document.getElementById('store-handle').dataset.mapSaturation;
    var defaults = {
      map: {
        zoom: 0,
        center: {
          lat: -40.895021,
          lng: 170.5285246
        },
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        maxZoom: 15,
        styles: [{
          stylers: [{
            saturation: saturation
          }]
        }]
      },
      rawDataType: 'csv',
      googlePlacesFields: [
        'url',
      ],
      enableSearch: true
    };
  
    function StoreLocator(container) {
  
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.mapContainer = document.querySelector(selectors.mapContainer + this.sectionId);
  
      if (!this.container) {
        return;
      }
  
      this.data = {
        parsedData: {},
        parsedPostcodeData: {},
        stores: [],
        groups: [],
        filters: [],
        tags: [],
        activeFilters: [],
        activeStore: null,
        activeGroup: null,
        storesInFilter: [],
        storesInView: [],
      };
  
      this.methods = {
        focusStore: this._focusStore.bind(this),
        zoomToFitMarkers: this._zoomToFitMarkers.bind(this),
        selectGroup: this._focusGroup.bind(this),
        selectFilter: this._focusFilter.bind(this),
        clearFilter: this._clearFilters.bind(this),
        findUser: this._findUser.bind(this),
      };
  
      this._prepareData();
      this._bindView();
      this._buildMap();
  
      if ("geolocation" in navigator) {
        this.data.geolocationEnabled = true;
      }
  
      this.data.is_ready = true;
  
    }
  
    StoreLocator.prototype = _.extend({}, StoreLocator.prototype, {
  
      _focusFilter: function() {
  
        var id,
            filter;
  
        id = event.currentTarget.dataset.filterId;
        filter = _.find(this.data.filters, {'id': id});
  
        if (!filter) {
          console.error(new Error('No filter found!'));
          return;
        }
  
        if (filter.active) {
          this._setActiveFilter(filter, 'remove');
        } else {
          this._setActiveFilter(filter, 'add');
        }
  
      },
  
      _setActiveFilter: function(filter, action, updateMap) {
  
        var self = this;
  
        // action = 'add', 'remove', 'replace', 'reset'
  
        if (!action) {
          console.error('An action must be defined');
          console.error('action = add, remove, replace, reset');
          return;
        }
  
        this._setActiveStore(false, false);
  
        switch(action) {
  
          case 'replace':
  
            _.each(this.data.activeFilters, function(filter) {
              filter.active = false;
            });
  
            this.data.activeFilters = [];
  
            filter.active = true;
            this.data.activeFilters.push(filter);
            break;
  
          case 'remove':
  
            filter.active = false;
            _.remove(this.data.activeFilters, {'id': filter.id});
            break;
  
          case 'add':
  
            filter.active = true;
            this.data.activeFilters.push(filter);
            break;
  
          case 'reset':
  
            _.each(this.data.activeFilters, function(filter) {
              filter.active = false;
            });
  
            this.data.activeFilters = [];
            break;
  
        }
  
        _.each(this.data.stores, function(store, i) {
          var storeInFilter = true;
  
          _.each(self.data.activeFilters, function(filter) {
  
            if (!store.tags || store.tags.indexOf(filter.tag) == -1) {
              storeInFilter = false;
            }
  
          });
  
          if (storeInFilter) {
            self._addStoreToFilter(store);
          } else {
            self._removeStoreFromFilter(store);
          }
  
        });
  
        if (self.data.activeFilters.length == 0) {
          this.data.storesAreFiltered = false;
        } else {
          this.data.storesAreFiltered = true;
        }
  
        this._getMarkersInView();
  
        this._toggleFiltersNoResultsMessage();
  
      },
  
      _toggleFiltersNoResultsMessage: function() {
  
        if (this.data.storesAreFiltered && this.data.storesInFilter.length == 0) {
          this.data.filterNoResults = true;
        } else {
          this.data.filterNoResults = false;
        }
  
      },
  
      _clearFilters: function() {
        this._setActiveFilter(false, 'reset');
      },
  
      _addStoreToFilter: function(store) {
  
        if (store.in_filter == true) {
          return;
        }
  
        store.in_filter = true;
        store.marker.setMap(this.map);
        store.markerCluster.addMarker(store.marker);
        store.markerCluster.redraw();
  
        this.data.storesInFilter.push(store);
  
      },
  
      _removeStoreFromFilter: function(store) {
  
        if (store.in_filter == false) {
          return;
        }
  
        store.in_filter = false;
        store.markerCluster.removeMarker(store.marker);
        store.marker.setMap(null);
        store.markerCluster.redraw();
  
        _.pull(this.data.storesInFilter, store);
  
      },
  
      _focusStore: function() {
  
        var id,
            store;
  
        id = event.currentTarget.dataset.storeId;
        store = _.find(this.data.stores, {'id': id});
  
        if (!store) {
          console.error(new Error('No store found!'));
          return;
        }
  
        // If a link is cliked, only follow the link if the store is active
        if (event.target && event.target.nodeName == 'A') {
          if (store.active) {
            return;
          } else {
            event.preventDefault();
          }
        }
  
        this._setActiveStore(store);
  
      },
  
      _setActiveStore: function(store, updateMap) {
  
        var self = this;
  
        var marker,
            markerPosition,
            activeStore,
            currentMapBounds,
            currentMapZoom,
            boundsContainsMarker;
  
        activeStore = this.data.activeStore;
  
        if (activeStore) {
          activeStore.active = false;
  
          if (activeStore.infoWindow) {
            activeStore.infoWindow.close();
          }
  
        }
  
        if (store == false) {
          this.data.activeStore = null;
          return;
        }
  
        if (updateMap != false) {
  
          marker = store.marker;
  
          markerPosition = marker.getPosition();
          currentMapBounds = this.map.getBounds();
          boundsContainsMarker =  currentMapBounds.contains(markerPosition);
          currentMapZoom = this.map.getZoom();
  
          if (!boundsContainsMarker || currentMapZoom < 12) {
            this.map.panTo(markerPosition);
            this.map.setZoom(4);
          }
  
        }
  
        if (store.group) {
          this._setActiveGroup(store.group, false);
        }
  
        this.data.activeStore = store;
        store.active = true;

        if (false && store.place_id && !store.place && !store.is_loading) {
            this._fetchStoreDetails(store, function() {
                console.log("OK");
            });
            self._openStoreInfoWindow(store);
        }
  
      },
  
      _fetchStoreDetails: function(store, callback) {
  
        var request;
  
        store.is_loading = true;
  
        request = {
          placeId: store.place_id,
          fields: defaults.googlePlacesFields
        };

        console.log("request", request);
  
        function formatOpeningHours(periods) {
          // Formats opening hours provided by Google Places API
          console.log('periods:', periods);
  
          var days,
              dayNames,
              dayIndex,
              dayTitle,
              daysString,
              openAmPm,
              openHours,
              openMinutes,
              openTime,
              closeAmPm,
              closeHours,
              closeMinutes,
              closeTime,
              timesString;
  
          days = [];
          dayNames = ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'];
  
          _.each(periods, function(period) {
  
            dayIndex = period.open.day;
            dayTitle = dayNames[dayIndex];
  
            openAmPm = (period.open.hours < 12 ? 'am' : 'pm');
            openHours = (period.open.hours < 12 ? period.open.hours : period.open.hours - 12);
            openMinutes = (period.open.minutes ? ':' + period.open.minutes : '');
            openTime = openHours + openMinutes + openAmPm;
  
            closeAmPm = (period.close.hours < 12 ? 'am' : 'pm');
            closeHours = (period.close.hours < 12 ? period.close.hours : period.close.hours - 12);
            closeMinutes = (period.close.minutes ? ':' + period.close.minutes : '');
            closeTime = closeHours + closeMinutes + closeAmPm;
  
            timesString = openTime + ' - ' + closeTime;
  
            daysString = dayTitle;
  
            function TimePeriod(options) {
              _.extend(this, options);
            }
  
            days.push(new TimePeriod({
              startDay: dayTitle,
              endDay: dayTitle,
              daysString: daysString,
              timesString: timesString,
              open: openTime,
              close: closeTime,
            }));
  
          });
  
          _.each(days, function(day, i) {
            var nextDay;
  
            nextDay = days[i + 1];
  
            if (nextDay && day.timesString == nextDay.timesString) {
              nextDay.startDay = day.startDay;
              nextDay.daysString = nextDay.startDay + ' - ' + nextDay.endDay;
              day.toDelete = true;
            }
  
          });
  
          _.remove(days, {'toDelete': true});
  
          return days;
  
        }
  
        this.placesService.getDetails(request, function(place, status) {

            console.log(123);
            console.log(google.maps.places.PlacesServiceStatus.OK);
  
          if (status === google.maps.places.PlacesServiceStatus.OK) {
  
            store.place = place;
  
            // store.open_now = place.opening_hours.open_now;
            store.opening_hours = (place.opening_hours.periods ? formatOpeningHours(place.opening_hours.periods) : []);
            // store.int_phone = place.international_phone_number;
            // store.phone = (place.formatted_phone_number ? place.formatted_phone_number.replace(/\-/g, ' ') : false);
            // store.permanently_closed = place.permanently_closed;
            store.google_url = place.url;

            console.log('store.opening_hours:', store.opening_hours);
  
            store.is_loading = false;
  
            if (callback && typeof callback == 'function') {
              callback();
            }
  
          } else {
            console.error(new Error('Error receiving data from Places service'));
  
            if (callback && typeof callback == 'function') {
              callback();
            }
          }
  
        });
  
      },
  
      _focusGroup: function() {
  
        var id,
            group;
  
        id = event.currentTarget.value;
  
        if (id == '' || id =='none') {
          this._setActiveGroup(false);
          return;
        }
  
        group = _.find(this.data.groups, {'id': id});
  
        if (!group) {
          console.error(new Error('No group found!'));
          return;
        }
  
        this._setActiveGroup(group);
  
      },
  
      _setActiveGroup: function(group, updateMap) {
  
        var self = this;
  
        var center,
            address,
            markerPosition,
            activeGroup;
  
        activeGroup = this.data.activeGroup;
        if (activeGroup) {
          activeGroup.active = false;
        }
  
        if (group == false) {
          this.data.activeGroup = null;
          this._zoomToFitMarkers();
          this._setActiveStore(false, false);
          return;
        }
  
        this.data.activeGroup = group;
        group.active = true;
  
        if (updateMap == false) {
          return;
        }
  
        this._setActiveStore(false, false);
  
        if (group.markers.length > 1) {
  
          bounds = new google.maps.LatLngBounds();
  
          _.each(group.markers, function(marker, i) {
            bounds.extend(marker.getPosition());
          });
  
          self.map.fitBounds(bounds);
  
        } else {
  
          markerPosition = group.markers[0].getPosition();
  
          this.map.panTo(markerPosition);
          this.map.setZoom(14);
  
        }
      },
  
      _prepareData: function() {
  
        var self = this;
  
        this._getData(processData);
  
        function processData() {
  
          self._prepareStoresData();
        }
  
      },
  
      _getData: function(callback) {
  
        var dataContainer,
            rawData,
            parsedPostcodeData,
            parsedData,
            parseOptions,
            rawDataType;
  
        dataContainer = document.querySelector(selectors.storesDataContainer);
  
        rawDataType = defaults.rawDataType;
  
        if (!dataContainer) {
          console.error(new Error('Missing data container'));
          return;
        }
  
        rawData = dataContainer.innerHTML;
  
        switch(rawDataType) {
  
          case 'json':
  
            this.data.parsedData.data = JSON.parse(rawData);
            callback();
            return;
  
          case 'csv':
  
            parseOptions = {
              header: true,
              dynamicTyping: true
            };

            console.log("rawData", rawData);
  
            this.data.parsedData = Papa.parse(rawData, parseOptions);
             this.data.parsedPostcodeData = Papa.parse(rawData, {
              header: true,
              dynamicTyping: false
            });

            if (this.data.parsedPostcodeData.data && this.data.parsedPostcodeData.data.length > 0) {
              this.data.parsedPostcodeData.data.forEach(store => {
                if (store.zip) {
                  store.zip = store.zip.toString();
                }
              });
            }

            if (
                this.data.parsedData.data &&
                this.data.parsedData.data.length > 0 &&
                this.data.parsedPostcodeData.data &&
                this.data.parsedPostcodeData.data.length > 0
            ) {
              this.data.parsedData.data.forEach((store, index) => {
                if (this.data.parsedPostcodeData.data[index] && this.data.parsedPostcodeData.data[index].zip) {
                  store.zip = this.data.parsedPostcodeData.data[index].zip;
                }
              });
            }

            console.log("this.data.parsedData", this.data.parsedData);

            callback();
            return;
  
          default:
  
            this.data.parsedData.data = rawData;
            callback();
            return;
  
        }
  
      },
  
      _prepareStoresData: function() {
  
        var self = this;
  
        var locationMarkerSVG,
            googleMapsSearchURLPrefix;
  
        locationMarkerSVG = theme.utils.getTemplate('store-location-marker-icon');
        googleMapsSearchURLPrefix = 'https://www.google.com/maps/search/';
  
        function Store(data) {
  
          _.extend(this, data);
  
          this.id = theme.utils.handleize(this.title);
          this.icon = locationMarkerSVG;
          this.google_url = googleMapsSearchURLPrefix + theme.utils.handleize(this.title).replace(/\-/g, '+') + '+' + theme.utils.handleize(this.street).replace(/\-/g, '+');
          if (data.place_id) {
            this.google_url = googleMapsSearchURLPrefix + "?api=1&query=" + theme.utils.handleize(this.title).replace(/\-/g, '+') + "&query_place_id=" + data.place_id;
          }
          if (this.opening_hours ) {
            this.opening_hours = _.map(this.opening_hours.split(/;/), function(period) {
                return _.map(period.replace(/:/, '#').split(/#/), _.trim);
            });
          }
        }
        
  
        if (self.data.parsedData.errors && self.data.parsedData.errors.length > 0) {
          console.error(new Error('There was an error parsing data'));
          console.error(data.parsedData.errors);
          return;
        }
  
        var storeHandle = document.getElementById('store-handle').dataset.handle;
        _.each(self.data.parsedData.data, function(value) {
  
          if (value.handle != storeHandle) {
            return;
          }
          
          var store,
              locationData,
              existingArea;
  
          // Build store data
          store = new Store(value);
          self.data.stores.push(store);
  
        });
  
        // Sort stores by title
        // self.data.stores = _.orderBy(self.data.stores, ['title'], ['city'], ['street']);
  
      },
  
      _bindView: function() {
  
        tinybind.bind(this.container, {
          data: this.data,
          methods: this.methods
        });
  
      },
  
      _buildMap: function() {
  
        var self = this;
  
        var googleMapsAPIURL,
            googleMapsAPIKEY,
            googleMapsAdditionalLibraries;
  
        googleMapsAPIURL = 'https://maps.googleapis.com/maps/api/js?key=';
        googleMapsAPIKEY = shop.keys.googleMaps;
        googleMapsAdditionalLibraries = '&libraries=places';
  
        if (!googleMapsAPIKEY) {
          return console.error(new Error('Google Maps API key is required. You can set this up as as Store metafield: '))
        }
  
        var options = defaults.map;
  
        function initMap() {
          self.geocoder = new google.maps.Geocoder();
          self.map = new google.maps.Map(self.mapContainer, options);
          self.placesService = new google.maps.places.PlacesService(self.map);
          self._addMapMarkers();
        }
  
        loadJS(googleMapsAPIURL + googleMapsAPIKEY + googleMapsAdditionalLibraries, initMap);
  
      },
  
      _addMapMarkers: function() {
  
        var self = this;
  
        _.each(this.data.stores, function(store, i) {
          var position,
              icon;
  
          position = {
            'lat': store.lat,
            'lng': store.long
          };
  
          icon = store.icon;
  
          store.marker = new google.maps.Marker({
            position: position,
            map: self.map,
            icon: {
              url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
              size: new google.maps.Size(28, 40),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(14, 40),
              scaledSize: new google.maps.Size(28, 40)
            },
            optimized: false
          });
  
          store.marker.addListener('click', function() {
            self._setActiveStore(store);
          });
        });
  
        this._clusterMarkers();
        this._zoomToFitMarkers();
        this._bindMapListners();
  
      },
  
      _clusterMarkers: function() {
        var self = this;
  
        var clusterMarkerSVG = theme.utils.getTemplate('store-location-marker-icon');
  
        _.each(this.data.groups, function(group, i) {
  
          var clusterStyles = [
            {
              width: 28,
              height: 40,
              url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(clusterMarkerSVG),
              textColor: 'transparent',
              textSize: 0,
              iconAnchor: [50, 100],
            }
          ];
  
          group.markerCluster = new MarkerClusterer(self.map, group.markers, {
            gridSize: 30,
            styles: clusterStyles,
            zoomOnClick: true,
          });
  
          _.each(group.stores, function(store) {
            store.markerCluster = group.markerCluster;
          });
  
        });
  
      },
  
      _zoomToFitMarkers: function() {
  
        var bounds = new google.maps.LatLngBounds();
  
        _.each(this.data.stores, function(store, i) {
          bounds.extend(store.marker.getPosition());
        });
  
        this.map.fitBounds(bounds);
  
      },
  
      _bindMapListners: function() {
  
        var self = this;
  
        this.map.addListener('bounds_changed', _.debounce(this._getMarkersInView.bind(self), 50));
  
      },
  
      _unbindMapListners: function() {
  
        var self = this;
  
        google.maps.event.clearListeners(this.map, 'bounds_changed');
  
      },
  
      _getMarkersInView: function() {
  
        var self = this;
  
        this.data.storesInView = [];
        this.data.storesInActiveGroup = [];
  
        // this.data.activeGroupTitle = 'none';
  
        var bounds = this.map.getBounds();
  
        _.each(this.data.stores, function(store, i) {
          var markerPosition,
              boundsContainsMarker;
  
          markerPosition = store.marker.getPosition();
          boundsContainsMarker =  bounds.contains(markerPosition);
  
          if (boundsContainsMarker && (!self.data.storesAreFiltered || self.data.storesAreFiltered && store.in_filter)) {
            store.in_view = true;
            self.data.storesInView.push(store);
          } else {
            store.in_view = false;
          }
  
          if (store.group == self.data.activeGroup) {
            store.in_active_group = true;
            self.data.storesInActiveGroup.push(store);
          } else {
             store.in_active_group = false;
          }
  
        });
  
        if (this.data.storesInView && this.data.storesInView.length == 1) {
          var store = this.data.storesInView[0];
  
          if (store != self.data.activeStore) {
            this._setActiveStore(store, false);
          }
         
        }
  
      },
  
      _findUser: function() {
  
        var self = this;
  
        this.data.geolocationLoading = true;
  
        function success(position) {
          var pos;
  
          pos = {
            lat: position.coords.latitude,
            long: position.coords.longitude
          };
  
          userLocation = new google.maps.LatLng(pos.lat, pos.long);
  
          self._updateUserMarker(userLocation);
  
          self._findClosestStore(userLocation);
          self.data.geolocationLoading = false;
        }
  
        function error() {
  
          self.data.geolocationLoading = false;
          self.data.geolocationEnabled = false;
  
          iziToast.error({
            title: 'We couldn\'t find your location',
            position: 'bottomCenter',
            theme: 'light',
          });
  
        }
  
        navigator.geolocation.getCurrentPosition(success, error);
  
      },
  
      _findClosestStore: function(latLng) {
  
        var self = this;
  
        var closestStore,
            bounds,
            userLocation;
  
        bounds = new google.maps.LatLngBounds();
  
        closestStore = getClosestStore(latLng);
  
        self._setActiveStore(closestStore, false);
  
        bounds.extend(closestStore.marker.getPosition());
        bounds.extend(latLng);
  
        self.map.fitBounds(bounds);
  
        function getClosestStore(latLng) {
  
          // https://stackoverflow.com/questions/4057665/google-maps-api-v3-find-nearest-markers
          var lat = latLng.lat();
          var long = latLng.lng();
          var R = 6371; // radius of earth in km
          var distances = [];
          var closest = -1;
  
          var closestStore = null;
  
          function rad(x) {return x*Math.PI/180;}
  
          _.each(self.data.stores, function(store, i) {
  
              var mlat = store.lat;
              var mlng = store.long;
  
              var dLat  = rad(mlat - lat);
              var dLong = rad(mlng - long);
              var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
              var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
              var d = R * c;
              distances[i] = d;
  
              if ( closest == -1 || d < distances[closest] ) {
                  closest = i;
                  closestStore = store;
              }
  
          });
  
          return closestStore;
  
        }
  
      },
  
      _updateUserMarker: function(latLng) {
  
        var self = this;
  
        var pos,
            icon,
            user,
            locationMarkerSVG;
  
        if (!latLng) {
          console.error(new Error('latLng must be defined'));
          return;
        }
  
        function User(data) {
          _.extend(this, data);
        }
  
        if (!this.data.user) {
  
          locationMarkerSVG = theme.utils.getTemplate('user-location-marker-icon');
          this.data.user = new User({
            icon: locationMarkerSVG
          });
  
        }
  
        user = this.data.user;
  
        user.latLng = latLng;
  
        if (!user.marker) {
          icon = user.icon;
  
          user.marker = new google.maps.Marker({
            position: user.latLng,
            map: self.map,
  
            icon: {
              url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
              size: new google.maps.Size(24, 24),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(12, 12),
              scaledSize: new google.maps.Size(24, 24)
            },
  
            optimized: false
  
          });
  
        } else {
  
          user.marker.setPosition(user.latLng);
  
        }
  
      },
  
      _updateSearchMarker: function(latLng) {
  
        var self = this;
  
        var pos,
            icon,
            locationMarkerSVG;
  
        if (!latLng) {
          console.error(new Error('latLng must be defined'));
          return;
        }
  
        function Search(data) {
          _.extend(this, data);
        }
  
        if (!this.data.search) {
  
          locationMarkerSVG = theme.utils.getTemplate('search-location-marker-icon');
          this.data.search = new Search({
            icon: locationMarkerSVG
          });
  
        }
  
        search = this.data.search;
        search.latLng = latLng;
  
        if (!search.marker) {
  
          icon = search.icon;
  
          search.marker = new google.maps.Marker({
            position: search.latLng,
            map: self.map,
  
            icon: {
              url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
              size: new google.maps.Size(24, 24),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(12, 12),
              scaledSize: new google.maps.Size(24, 24)
            },
  
            optimized: false
  
          });
  
        } else {
  
          search.marker.setPosition(search.latLng);
  
        }
  
      },
  
  
    });
    
    return StoreLocator;
  
  })();
  
  new theme.StoreLocator(document.getElementById('store-locator-section-wrapper'));